export const SET_CARGA_PAGINA = "SET_CARGA_PAGINA"
export const SET_CARGA_CONTENIDO = "SET_CARGA_CONTENIDO"
export const SET_ESTADO_NOTIFICACION_PP = "SET_ESTADO_NOTIFICACION_PP"